
const tabs = (tabsSelector, wrapperSelector) => {
    const tabs = document.querySelector(tabsSelector),
          wrapper = document.querySelector(wrapperSelector);
    if(tabs) {
        tabs.children.forEach(tab => {

            tab.addEventListener('click', (e) => {
                tabs.children.forEach(tab => tab.classList.remove('tab_active'))
                tab.classList.add('tab_active');
    
    
                wrapper.children.forEach(block => {
                    if(block.classList[1] === e.target.classList[1])  {
                        if(block.classList.contains(e.target.classList[1])) {
                            wrapper.children.forEach(item => {
                                item.style.transition =`0s`;
                                item.style.visibility = 'hidden';
                                item.style.opacity = 0;
                                item.style.position = 'absolute';
                                item.style.right = '0';
                                // item.style.height = '10px';
                                
                            });
                            block.style.transition =`1s`;
                            block.style.visibility = 'visible';
                            block.style.opacity = 1;
                            block.style.position = 'relative';

                            // block.style.height = 'auto';
                        } 
                    }
                })
            })
        })
    }
   
}

export default tabs;